export const orderFragment = /* GraphQL */ `
  fragment orderData on Order {
    id
    orderUserId
    toUserID
    name
    email
    status
    shopID
    type
    requestType
    phone
    items
    dates
    message
    stripeID
    metadata {
      key
      type
      value
    }
    customer {
      id
      firstName
      lastName
      email
      companyName
      VAT
      SIRET
      address
      city
      country
      notes
      phone
      type
      zipcode
    }
    billingAddress {
      address
      city
      country
      email
      name
      phone
      zipcode
    }
    deliveryAddress {
      address
      city
      country
      email
      name
      phone
      zipcode
    }
    user {
      id
      name
      email
      phone
      company
      SIRET
      address
      city
      zipcode
      country
    }
    toUser {
      id
      name
      email
      phone
      company
      SIRET
      address
      city
      zipcode
      country
    }
    toOrganization {
      id
      name
      email
      phone
      SIRET
      address
      city
      zipcode
      country
      logo
    }
    shop {
      id
      accountID
      userID
      company
      logo
      contacts
      phone
      organizationID
      organizationMasterID
      organization {
        name
        email
        address
        zipcode
        city
        country
        SIRET
        phone
      }
      user {
        id
        name
        email
        phone
      }
    }
    total {
      amount
      currency
    }
    tax {
      amount
      currency
    }
    updatedAt
    createdAt
    yousignID
    yousignStatus
    document
    organizationID
    organizationMasterID
    organization {
      id
      parentID
      masterID
    }
    toOrganizationID
    managerID
  }
`
